<script setup>
// Area ligada e ainda sem uso: em vez de numero zerado, o primeiro passo.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  area: { type: String, required: true },
});

const { t } = useI18n();

const step = computed(
  () =>
    ({
      service: {
        icon: 'i-lucide-message-square-plus',
        to: 'settings_inbox_new',
        title: t('VINCTO_HOME.EMPTY.SERVICE.TITLE'),
        text: t('VINCTO_HOME.EMPTY.SERVICE.TEXT'),
        action: t('VINCTO_HOME.EMPTY.SERVICE.ACTION'),
      },
      deals: {
        icon: 'i-lucide-kanban',
        to: 'kanban_list',
        title: t('VINCTO_HOME.EMPTY.DEALS.TITLE'),
        text: t('VINCTO_HOME.EMPTY.DEALS.TEXT'),
        action: t('VINCTO_HOME.EMPTY.DEALS.ACTION'),
      },
      activities: {
        icon: 'i-lucide-calendar-plus',
        to: 'crm_calendar',
        title: t('VINCTO_HOME.EMPTY.ACTIVITIES.TITLE'),
        text: t('VINCTO_HOME.EMPTY.ACTIVITIES.TEXT'),
        action: t('VINCTO_HOME.EMPTY.ACTIVITIES.ACTION'),
      },
    })[props.area]
);
</script>

<template>
  <div
    class="flex flex-col items-center gap-3 px-6 py-12 text-center border rounded-2xl border-n-weak bg-white dark:bg-n-solid-2"
  >
    <i :class="step.icon" class="w-8 h-8 text-n-slate-10" />
    <p class="mb-0 text-base font-medium text-n-slate-12">
      {{ step.title }}
    </p>
    <p class="max-w-md mb-0 text-sm text-n-slate-11">
      {{ step.text }}
    </p>
    <router-link
      :to="{ name: step.to }"
      class="px-3 py-1.5 text-sm font-medium text-white rounded-lg bg-n-brand hover:brightness-110"
    >
      {{ step.action }}
    </router-link>
  </div>
</template>
